const SET_OUTSTANDING_REQUESTS = 'SET_OUTSTANDING_REQUESTS';

export const setOutstandingRequests = (action) => ({
  type: SET_OUTSTANDING_REQUESTS,
  action,
})